import React, { Fragment, useEffect, useState } from "react";
import PageHeader from "../../common/components/PageHeader";
import { Box, Grid, Stack, Typography } from "@mui/material";
import { FiberManualRecord } from "@mui/icons-material";
import CommonButton from "../../common/components/CommonButton";
import CommonCard from "../../common/components/CommonCard";
import theme from "../../theme";
import { useLocation } from "react-router-dom";
import MentorListing from "./MentoringListing";
import CurrentPlan from '../../common/components/CurrentPlan';
import { ServiceOffer, ServiceTabs } from "../../common/const";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import { useDispatch } from "react-redux";
import { setLoading } from "../../features/authSlice";
import { getMentorList } from "../../api/mentorApi";
import { getAllSubject } from "../../api/subjectApi";


const BookSession = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const searchParams = new URLSearchParams(location.search);

    // Extract all parameters
    const details = {
        type: searchParams.get('type'),
        id: searchParams.get('id'),
        pid: searchParams?.get('pid')
    };

    const [mentors, setMentors] = useState(null);
    const [serviceType, setServiceType] = useState(ServiceTabs[details?.type]);
    const [currentPage, setCurrentPage] = useState(1);
    const [subjects, setSubjects] = useState([]);
    const [subService, setSubService] = useState(null);
    const pageSize = 12;

    const getMentorData = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await getMentorList(
                currentPage,
                pageSize,
                JSON.stringify([
                    !subService ? { "column": "service_offers", "op": "has", "value": ServiceOffer[details?.type] } :
                        { "column": "services", "op": "hasSome", "service_name": ServiceOffer[details?.type], "sub_service": [subService] }]),
                '',
                true
            );
            setMentors(response.data);
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            setMentors(null);
            dispatch(setLoading({
                loading: false
            }));
        }
    }

    const getSubjects = async () => {
        try {
            const response = await getAllSubject(
                1,
                100,
                ServiceOffer[details?.type] === 'CODING_SKILLS_TECHNOLOGY' ? 'SKILL' : ServiceOffer[details?.type],
                ''
            );
            setSubService(response?.data?.data[0]?.description);
            setSubjects(response?.data?.data);
        } catch (error) {
            console.error('Error fetching subjects:', error);
            showNotification('Failed to load subjects', 'error');
        }
    };


    useEffect(() => {
        getMentorData();
    }, [currentPage, subService]);

    useEffect(() => {
        getSubjects();
    }, []);

    return (
        <Fragment>
            <PageHeader
                title="Book a New Session"
                content={
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <Typography color="text.secondary" sx={{ fontSize: 14, }}>
                            My DCP Services
                        </Typography>
                        <FiberManualRecord sx={{ fontSize: 8, color: 'text.secondary' }} />
                        <Typography color="text.secondary" sx={{ fontSize: 14, }}>
                            Book a New Session
                        </Typography>
                    </Stack>
                }
            />
            <Grid container spacing={1} mt={0.5}>
                <Grid item md={8}>
                    <CommonCard
                        borderRadius={2}
                        paddingBottom="0px"
                        marginTop="0px"
                        content={
                            <Box>
                                <Typography fontWeight={600} fontSize={18}>{`Choose Your ${details?.type === 'coach' ? 'SAT/ACT Coach' : details?.type === 'mentor' ? 'Project Mentor' : details?.type === 'tutor' ? 'Tutor' : 'Counselor'}`}</Typography>
                                <Typography fontSize={13} color={theme.palette.background.dark}>Find the perfect expert to guide your AI journey</Typography>
                            </Box>
                        }
                    />
                    <Box mt={1} display="flex" gap={1}>
                        <CommonButton
                            label={ServiceTabs.coach}
                            width="150px"
                            fontWeight={600}
                            border={serviceType !== ServiceTabs.coach ? `1px solid #0000001A` : 'none'}
                            color={serviceType === ServiceTabs.coach ? theme.palette.secondary.main : 'gray'}
                            background={serviceType === ServiceTabs.coach ? theme.palette.primary.main : '#FAFAFA'}
                            handleClick={() => setServiceType(ServiceTabs.coach)}
                            marginBottom="0px"
                            disabled={serviceType !== ServiceTabs.coach}
                        />
                        <CommonButton
                            label={ServiceTabs.tutor}
                            width="180px"
                            fontWeight={600}
                            border={serviceType !== ServiceTabs.tutor ? `1px solid #0000001A` : 'none'}
                            color={serviceType === ServiceTabs.tutor ? theme.palette.secondary.main : 'gray'}
                            background={serviceType === ServiceTabs.tutor ? theme.palette.primary.main : '#FAFAFA'}
                            handleClick={() => setServiceType(ServiceTabs.tutor)}
                            marginBottom="0px"
                            disabled={serviceType !== ServiceTabs.tutor}
                        />
                        <CommonButton
                            label={ServiceTabs.academic}
                            width="180px"
                            fontWeight={600}
                            border={serviceType !== ServiceTabs.academic ? `1px solid #0000001A` : 'none'}
                            color={serviceType === ServiceTabs.academic ? theme.palette.secondary.main : 'gray'}
                            background={serviceType === ServiceTabs.academic ? theme.palette.primary.main : '#FAFAFA'}
                            handleClick={() => setServiceType(ServiceTabs.academic)}
                            marginBottom="0px"
                            disabled={serviceType !== ServiceTabs.academic}
                        />
                        <CommonButton
                            label={ServiceTabs.mentor}
                            width="160px"
                            fontWeight={600}
                            border={serviceType !== ServiceTabs.mentor ? `1px solid #0000001A` : 'none'}
                            color={serviceType === ServiceTabs.mentor ? theme.palette.secondary.main : 'gray'}
                            background={serviceType === ServiceTabs.mentor ? theme.palette.primary.main : '#FAFAFA'}
                            handleClick={() => setServiceType(ServiceTabs.mentor)}
                            marginBottom="0px"
                            disabled={serviceType !== ServiceTabs.mentor}
                        />
                        <CommonButton
                            label={ServiceTabs.skillCoach}
                            width="200px"
                            fontWeight={600}
                            border={serviceType !== ServiceTabs.skillCoach ? `1px solid #0000001A` : 'none'}
                            color={serviceType === ServiceTabs.skillCoach ? theme.palette.secondary.main : 'gray'}
                            background={serviceType === ServiceTabs.skillCoach ? theme.palette.primary.main : '#FAFAFA'}
                            handleClick={() => setServiceType(ServiceTabs.skillCoach)}
                            marginBottom="0px"
                            disabled={serviceType !== ServiceTabs.skillCoach}
                        />
                    </Box>
                    <Grid container spacing={1} mt={1}>
                        {subjects.length > 0 && subjects.map((a) => (
                            <Grid item sm={12} md={2}>
                                <CommonButton
                                    label={a.name}
                                    width="150px"
                                    fontWeight={600}
                                    border={subService !== a.description ? `1px solid #0000001A` : 'none'}
                                    color={subService === a.description ? theme.palette.secondary.main : 'gray'}
                                    background={subService === a.description ? theme.palette.primary.main : '#FAFAFA'}
                                    handleClick={() => setSubService(a.description)}
                                    marginBottom="0px"
                                />
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
                <Grid item md={4}>
                    <CurrentPlan />
                </Grid>
                <Grid item md={12}>
                    <MentorListing
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        totalPages={mentors?.pagination?.totalPages}
                        itemsPerPage={pageSize}
                        mentors={mentors?.data}
                        details={details}
                    />
                </Grid>
            </Grid>
        </Fragment>
    )
}

export default BookSession;